import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { FeatureFlagsService } from '../services/feature-flags.service';
import { LanguageService } from '@shared/partner-ui/services/language.service';

export const winesFeatureGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const featureFlags = inject(FeatureFlagsService);
  const language = inject(LanguageService);

  const flags = await featureFlags.loadFlags().catch(() => featureFlags.snapshot());

  return flags.showWineryWines ? true : router.createUrlTree(['/', language.currentLanguage, 'story']);
};
